import { Box, Container, Typography } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import Lead1 from "../../assets/TeamLead/lead1.webp";
import Lead2 from "../../assets/TeamLead/lead2.webp";
import Lead3 from "../../assets/TeamLead/lead3.webp";
import Lead4 from "../../assets/TeamLead/lead4.webp";
import Lead5 from "../../assets/TeamLead/lead5.webp";
import Lead6 from "../../assets/TeamLead/lead6.webp";
import Lead7 from "../../assets/TeamLead/lead7.webp";
import Lead8 from "../../assets/TeamLead/lead8.webp";
import Lead9 from "../../assets/TeamLead/lead9.webp";


const agents = [
  {
    id: 1,
    name: "Mosab Al Halaby",
    role: "Senior Property Consultant",
    image: Lead1,
    languages: ["Arabic", "English"],
    properties: 1065,
    desc: "Experienced senior consultant specializing in residential and investment properties across Sharjah and Dubai.",
  },
  {
    id: 2,
    name: "Zein Alabideen Hweijeh",
    role: "Property Consultant",
    image: Lead2,
    languages: ["Arabic", "English"],
    properties: 1173,
    desc: "Client-focused advisor delivering transparent guidance and market-driven real estate solutions.",
  },
  {
    id: 3,
    name: "Omar Al Laham",
    role: "Property Consultant",
    image: Lead3,
    languages: ["Arabic", "English"],
    properties: 1169,
    desc: "Specialist in buyer representation and rental markets with a strong negotiation background.",
  },
  {
    id: 4,
    name: "Anne Baloch",
    role: "Property Consultant",
    image: Lead4,
    languages: ["Urdu", "English"],
    properties: 1138,
    desc: "Dedicated consultant helping clients find the right homes and investment opportunities with confidence.",
  },
  {
    id: 5,
    name: "Vidhya Vinod",
    role: "Property Consultant",
    image: Lead5,
    languages: ["Hindi", "English", "Malayalam"],
    properties: 1134,
    desc: "Detail-oriented advisor focused on long-term value, trust, and client satisfaction.",
  },
  {
    id: 6,
    name: "Mahmoud Wehba",
    role: "Property Consultant",
    image: Lead6,
    languages: ["Arabic", "English"],
    properties: 729,
    desc: "Customer-first real estate professional delivering reliable sales and leasing advisory services.",
  },
  {
    id: 7,
    name: "Dhvani Patel",
    role: "Property Consultant",
    image: Lead7, // add image import
    languages: ["Hindi", "Tamil", "English", "Marathi", "Kannada"],
    properties: 669,
    desc: "Multilingual property consultant assisting diverse clients with residential and investment solutions.",
  },
  {
    id: 8,
    name: "Ayman Mohamed Abdulqadir",
    role: "Property Consultant",
    image: Lead8, // add image import
    languages: ["Arabic", "English"],
    properties: 659,
    desc: "Trusted advisor specializing in residential properties with a strong focus on client satisfaction.",
  },
  {
    id: 9,
    name: "Vimarsha Kavinda",
    role: "Property Consultant",
    image: Lead9, // add image import
    languages: ["Hindi", "English", "Sinhalese"],
    properties: 295,
    desc: "Client-oriented consultant helping buyers and tenants find the right property with confidence.",
  },
];



export default function OurAgents() {
  return (
    // <Box
    //   sx={{
    //     backgroundColor: "#212121",
    //     py: { xs: 10, md: 16 },
    //     position: "relative",
    //   }}
    // >
    <Box
      sx={{
        backgroundColor: "var(--color-bg)",
        py: { xs: 4, md: 4 },
        position: "relative",
      }}
    >
      <Container maxWidth="lg">
        {/* HEADER */}
        <Box textAlign="center" mb={{ xs: 2, md: 2 }}>
          <Typography
            sx={{
              color: "var(--color-gold)",
              letterSpacing: "0.35em",
              fontSize: 11,
              mb: 1,
            }}
          >
            OUR AGENTS
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "2rem", md: "3rem" },
              fontWeight: 500,
              // mb: 3,
            }}
          >
            <Box component="span" sx={{ color: "var(--color-text-primary)" }}>
              Elite Property{" "}
            </Box>

            <Box component="span" sx={{ color: "var(--color-gold)" }}>
              Consultants
            </Box>
          </Typography>

          <Typography
            sx={{
              // color: "rgba(255,255,255,0.65)",
              color: "var(--color-text-muted)",

              maxWidth: 620,
              mx: "auto",
              fontSize: 15,
              lineHeight: 2,
            }}
          >
            Meet our top-performing professionals delivering excellence,
            discretion, and market expertise.
          </Typography>
        </Box>

        {/* SLIDER */}
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={40}
          slidesPerView={1}
          centeredSlides
          loop
          navigation
          pagination={{ clickable: true }}
          breakpoints={{
            900: { slidesPerView: 3 },
          }}
          style={{
            paddingBottom: "60px",
            paddingTop: "30px",
            paddingLeft: "10px",
            paddingRight: "10px",
            borderRadius: "12px",
          }}
        >
          {agents.map((agent, i) => (
            <SwiperSlide key={i}>
              {/* <Box
                sx={{
                  background:
                    "linear-gradient(180deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))",
                  borderRadius: "28px",
                  p: { xs: 4, md: 5 },
                  textAlign: "center",
                  height: "100%",
                  border: "1px solid rgba(255,255,255,0.08)",
                  boxShadow: "0 40px 120px rgba(0,0,0,0.8)",
                  transition: "all 0.45s ease",

                  "&:hover": {
                    transform: "translateY(-10px)",
                    boxShadow:
                      "0 60px 160px rgba(0,0,0,0.95), 0 0 0 1px rgba(201,162,77,0.45)",
                  },
                }}
              > */}
              <Box
                sx={{
                  background: "var(--color-white)",
                  borderRadius: "28px",
                  p: { xs: 4, md: 5 },
                  textAlign: "center",
                  height: "100%",
                  border: "1px solid rgba(0,0,0,0.08)",
                  // boxShadow: "0 25px 60px rgba(0,0,0,0.18)",
                  transition: "all 0.45s ease",

                  "&:hover": {
                    transform: "translateY(-10px)",
                    boxShadow: "0 40px 90px rgba(0,0,0,0.25)",
                    borderColor: "var(--color-gold)",
                  },
                }}
              >
                {/* IMAGE */}
                <Box
                  sx={{
                    width: 110,
                    height: 110,
                    mx: "auto",
                    mb: 3,
                    borderRadius: "50%",
                    overflow: "hidden",
                    border: "2px solid var(--color-gold)",
                    boxShadow: "0 0 0 6px rgba(201,162,77,0.15)",
                  }}
                >
                  <Box
                    component="img"
                    src={agent.image}
                    alt={agent.name}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </Box>

                {/* NAME */}
                <Typography
                  sx={{
                    color: "var(--color-gold)",
                    fontSize: 18,
                    fontWeight: 500,
                    mb: 1,
                  }}
                >
                  {agent.name}
                </Typography>

                {/* LANGUAGES */}
                <Typography
                  sx={{
                    // color: "rgba(255,255,255,0.75)",
                    color: "var(--color-text-muted)",

                    fontSize: 13,
                    mb: 2,
                  }}
                >
                  {agent.languages.join(", ")}
                </Typography>

                {/* DESC */}
                <Typography
                  sx={{
                    // color: "rgba(255,255,255,0.65)",
                    color: "var(--color-text-muted)",

                    fontSize: 14,
                    lineHeight: 1.9,
                  }}
                >
                  {agent.desc}
                </Typography>
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>

      {/* PAGINATION GOLD STYLE */}
      <style>
        {`
        .swiper-pagination-bullet {
          background: rgba(201,162,77,0.35);
          opacity: 1;
        }
        .swiper-pagination-bullet-active {
          background: var(--color-gold);
        }
        .swiper-button-next,
        .swiper-button-prev {
          color: var(--color-gold);
        }
        `}
      </style>

      {/* BOTTOM GOLD LINE */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: "5%",
          right: "5%",
          height: "1px",
          background:
            "linear-gradient(90deg, transparent, var(--color-gold), transparent)",
          opacity: 0.6,
        }}
      />
    </Box>
  );
}
